/**
 * Created by shubham on 10/5/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { ManagerAssignmentComponent } from './managerAssignment.component';
import { ManagerListComponent } from './managerList/managerList.component';
import { AddManagerComponent } from './addManager/addManager.component';
import { ViewManagerComponent } from './viewManager/viewManager.component';

export const ManagerAssignmentRoutes: Routes = [
    {
        path: '',
        component: ManagerAssignmentComponent,
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'list', component: ManagerListComponent },
            { path: 'add', component: AddManagerComponent },
            { path: 'view/:buAssociationId', component: ViewManagerComponent }
        ]
    }
];

export const ManagerAssignmentRoutingModule = RouterModule.forChild(ManagerAssignmentRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/managerAssignment-routing.module.ts